import React from "react";
import { Box, Typography, IconButton, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import typography from "../cssUtils/typography";

// Right-side add/edit configuration panel used by bots, automations,
// autoresponders, etc. Deliberately NOT a MUI Drawer/Modal — it renders inline
// as a normal flex sibling next to the page content (same stacking context, no
// backdrop, no fixed positioning), so it pushes the content aside instead of
// overlaying it. `position: sticky` + its own `height: 100vh` keep it pinned to
// the viewport and scrolling independently of the (possibly much taller) list
// content beside it, instead of stretching to match that content's height with
// empty space below, or scrolling out of view with the page.
const SideDrawer = ({ open, onClose, title, subtitle, width = 480, children }) => {
  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        alignSelf: "flex-start",
        height: "100vh",
        width: open ? { xs: "100%", sm: width } : 0,
        flexShrink: 0,
        overflow: "hidden",
        borderLeft: open ? "1px solid #E5E7EB" : "none",
        transition: "width 0.25s ease, border-color 0.25s ease",
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", sm: width },
          height: "100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#FAFAFA",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 1.5,
            p: 3,
            pb: 2,
            backgroundColor: "#fff",
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ ...typography.h1, color: "#1D2330" }}>{title}</Typography>
            {subtitle && (
              <Typography
                sx={{ ...typography.bodySmall, color: "#6C7C93", mt: 0.25 }}
                noWrap
              >
                {subtitle}
              </Typography>
            )}
          </Box>
          <IconButton
            onClick={onClose}
            sx={{ color: "#6C7C93", flexShrink: 0, "&:hover": { bgcolor: "#F0F2F8", color: "#1D2330" } }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />
        <Box sx={{ flex: 1, overflowY: "auto", p: 3 }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default SideDrawer;
